import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group d-flex flex-wrap" }
const _hoisted_19 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group d-flex flex-wrap" }
const _hoisted_23 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group d-flex flex-wrap" }
const _hoisted_26 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group d-flex flex-wrap" }
const _hoisted_30 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group d-flex flex-wrap" }
const _hoisted_33 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group d-flex flex-wrap" }
const _hoisted_37 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group d-flex flex-wrap" }
const _hoisted_40 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_41 = { class: "d-flex flex-row align-items-center mb-5" }
const _hoisted_42 = { class: "mb-0" }
const _hoisted_43 = {
  type: "button",
  class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
  "aria-disabled": "true",
  "data-bs-toggle": "modal",
  title: "Add",
  "data-bs-target": "#modal_add_campaign"
}
const _hoisted_44 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_45 = { class: "mb-10" }
const _hoisted_46 = { class: "svg-icon svg-icon-3" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "svg-icon svg-icon-3" }
const _hoisted_49 = { class: "d-flex flex-row align-items-center mb-5" }
const _hoisted_50 = { class: "mb-0" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_53 = { class: "mb-10" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "svg-icon svg-icon-3" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "form-group d-flex flex-wrap" }
const _hoisted_60 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_61 = { class: "col-lg-8" }
const _hoisted_62 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "form-group d-flex flex-wrap" }
const _hoisted_65 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_66 = { class: "col-lg-8" }
const _hoisted_67 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = { class: "form-group d-flex flex-wrap" }
const _hoisted_70 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_71 = { class: "col-lg-8" }
const _hoisted_72 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_73 = { class: "col-md-6" }
const _hoisted_74 = { class: "form-group d-flex flex-wrap" }
const _hoisted_75 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_76 = { class: "col-lg-8" }
const _hoisted_77 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_78 = { class: "col-md-6" }
const _hoisted_79 = { class: "form-group d-flex flex-wrap" }
const _hoisted_80 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_81 = { class: "col-lg-8" }
const _hoisted_82 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_83 = { class: "col-md-6" }
const _hoisted_84 = { class: "form-group d-flex flex-wrap" }
const _hoisted_85 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_86 = { class: "col-lg-8" }
const _hoisted_87 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_88 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_90 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_91 = { class: "indicator-label" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_93 = { class: "indicator-progress" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_95 = { class: "card mb-5 mb-xl-10" }
const _hoisted_96 = { class: "card-header border-0" }
const _hoisted_97 = { class: "card-title m-0" }
const _hoisted_98 = { class: "fw-boldest m-0" }
const _hoisted_99 = { class: "card-body border-top p-9" }
const _hoisted_100 = { class: "row" }
const _hoisted_101 = { class: "col-md-6" }
const _hoisted_102 = { class: "form-group d-flex flex-wrap" }
const _hoisted_103 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_104 = { class: "el-form-item__content" }
const _hoisted_105 = { class: "col-md-6" }
const _hoisted_106 = { class: "form-group d-flex flex-wrap" }
const _hoisted_107 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_108 = { class: "el-form-item__content" }
const _hoisted_109 = { class: "col-md-6" }
const _hoisted_110 = { class: "form-group d-flex flex-wrap" }
const _hoisted_111 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_112 = { class: "el-form-item__content" }
const _hoisted_113 = { class: "col-md-6" }
const _hoisted_114 = { class: "form-group d-flex flex-wrap" }
const _hoisted_115 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_116 = { class: "el-form-item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ELDatatable = _resolveComponent("ELDatatable")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_AddMemberModal = _resolveComponent("AddMemberModal")!
  const _component_AddcommunityModal = _resolveComponent("AddcommunityModal")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("wechat.information")), 1)
        ])
      ]),
      _createVNode(_component_el_form, {
        onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        model: _ctx.formData,
        rules: _ctx.rules,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("wechat.communityName")), 1),
                  _createVNode(_component_el_form_item, { prop: "name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("wechat.communityManager")), 1),
                  _createVNode(_component_el_form_item, { prop: "manager" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.manager,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.manager) = $event)),
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsEnter'),
                        "remote-method": _ctx.searchManagerItems,
                        loading: _ctx.managerLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managerOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("wechat.purpose")), 1),
                  _createVNode(_component_el_form_item, { prop: "purpose" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.purpose,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.purpose) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purposeOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("wechat.dedicatedGroupLevel")), 1),
                  _createVNode(_component_el_form_item, { prop: "dedicated_group_level" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.dedicated_group_level,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.dedicated_group_level) = $event)),
                        clearable: "",
                        multiple: "",
                        "collapse-tags": "",
                        "collapse-tags-tooltip": "",
                        loading: _ctx.dedicatedGroupLevelLoading,
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dedicatedGroupLevelOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value,
                              style: {"width":"100%"}
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("wechat.mbSegmentation")), 1),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.mb_segmentation,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.mb_segmentation) = $event)),
                        clearable: "",
                        multiple: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "option1",
                            value: "1"
                          }),
                          _createVNode(_component_el_option, {
                            label: "option2",
                            value: "2"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("wechat.members")), 1),
                  _createVNode(_component_el_form_item, { prop: "members" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.members,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.members) = $event)),
                        modelModifiers: { number: true },
                        type: "number",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("wechat.startDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "start_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.start_date,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.start_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'start_date')
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("wechat.expiryDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "expiry_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.expiry_date,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.expiry_date) = $event)),
                        type: "date",
                        disabled: "",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t("wechat.proActiveActions")), 1),
                  _createVNode(_component_el_form_item, { prop: "pro_active_actions" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.pro_active_actions,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.pro_active_actions) = $event)),
                        clearable: "",
                        multiple: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.pro_active_actions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value,
                              style: {"width":"100%"}
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("wechat.subsistingActions")), 1),
                  _createVNode(_component_el_form_item, { prop: "subsisting_actions" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.subsisting_actions,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.subsisting_actions) = $event)),
                        clearable: "",
                        multiple: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.subsisting_actions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value,
                              style: {"width":"100%"}
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("h3", _hoisted_42, _toDisplayString(_ctx.t("wechat.relatedCampaigns")), 1),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_43, [
                _createElementVNode("span", _hoisted_44, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                ])
              ])), [
                [_directive_auth, { auth: ['update'] }]
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_el_table, {
                data: _ctx.formData.campaign_list,
                style: {"width":"100%"},
                size: "small",
                "min-width": "220"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('marketingCampaigns.campaignName'),
                    prop: "name"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('marketingCampaigns.campaignPurpose'),
                    prop: "purpose",
                    formatter: _ctx.getModelPurposeLabel
                  }, null, 8, ["label", "formatter"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('marketingCampaigns.startDate')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(row.start_date)), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('marketingCampaigns.endDate')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(row.end_date)), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('marketingCampaigns.status')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge", _ctx.getStatusLabel(row.status).statusClass])
                      }, _toDisplayString(_ctx.getStatusLabel(row.status).str), 3)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: "",
                    width: "100",
                    align: "right"
                  }, {
                    default: _withCtx(({ $index, row }) => [
                      _createVNode(_component_router_link, {
                        to: 
                    '/interactive-marketing/marketing-campaigns/' +
                    row.id +
                    '/Information'
                  ,
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_46, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _withDirectives((_openBlock(), _createElementBlock("button", {
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                        onClick: ($event: any) => (_ctx.deleteWechatCommunityCampaign($index, row))
                      }, [
                        _createElementVNode("span", _hoisted_48, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                        ])
                      ], 8, _hoisted_47)), [
                        [_directive_auth, { auth: ['update'] }]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("h3", _hoisted_50, _toDisplayString(_ctx.t("wechat.memberList")), 1),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
                "aria-disabled": "true",
                "data-bs-toggle": "modal",
                title: "Add",
                "data-bs-target": "#modal_add_member",
                disabled: _ctx.options.communityMemberLoading
              }, [
                _createElementVNode("span", _hoisted_52, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                ])
              ], 8, _hoisted_51)), [
                [_directive_auth, { auth: ['update'] }]
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_ELDatatable, {
                loading: _ctx.options.communityMemberLoading,
                "table-columns": _ctx.options.communityMemberColumns,
                "table-data": _ctx.options.communityMemberList,
                "current-page": _ctx.options.communityMemberCurrentPage,
                total: _ctx.options.communityMemberTotal,
                "rows-per-page": _ctx.options.communityMemberPageSize,
                onCurrentChange: _ctx.handleCurrentChange,
                onItemsPerPageChange: _ctx.setItemsPerPage
              }, {
                actions: _withCtx(({ row, $index }) => [
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                    onClick: ($event: any) => (_ctx.handleDeleteMemberModel($index, row))
                  }, [
                    _createElementVNode("span", _hoisted_55, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                    ])
                  ], 8, _hoisted_54)), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ]),
                _: 1
              }, 8, ["loading", "table-columns", "table-data", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange"])
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("wechat.rfmTracking")), 1),
            _hoisted_56,
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.t("wechat.totalLogins")), 1),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.formData.rfm_tacking.total_login_frequency), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.t("wechat.recentLogins")), 1),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.formData.rfm_tacking.last_thirty_days_login_frequency), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.t("wechat.totalOrders")), 1),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.formData.rfm_tacking.total_order), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.t("wechat.recentOrders")), 1),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.formData.rfm_tacking.last_thirty_days_order), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.t("wechat.totalGtv")), 1),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("span", _hoisted_82, "€ " + _toDisplayString(_ctx.formData.rfm_tacking.total_gtv), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.t("wechat.recentGtv")), 1),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("span", _hoisted_87, "€ " + _toDisplayString(_ctx.formData.rfm_tacking.last_thirty_days_gtv), 1)
                  ])
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_88, [
            _createVNode(_component_router_link, {
              to: '/interactive-marketing/wechat-communities/',
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _hoisted_89,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_90, [
              _createElementVNode("span", _hoisted_91, [
                _hoisted_92,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
              ]),
              _createElementVNode("span", _hoisted_93, [
                _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                _hoisted_94
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _createElementVNode("div", _hoisted_95, [
      _createElementVNode("div", _hoisted_96, [
        _createElementVNode("div", _hoisted_97, [
          _createElementVNode("h3", _hoisted_98, _toDisplayString(_ctx.t("common.historyLog")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_99, [
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.t("common.creator")), 1),
              _createElementVNode("div", _hoisted_104, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.created_user,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.__show.created_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.t("common.creationDate")), 1),
              _createElementVNode("div", _hoisted_108, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.created_at,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_109, [
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.t("common.lastModifiedBy")), 1),
              _createElementVNode("div", _hoisted_112, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.updated_user,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.__show.updated_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_113, [
            _createElementVNode("div", _hoisted_114, [
              _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.t("common.lastModifiedDate")), 1),
              _createElementVNode("div", _hoisted_116, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.updated_at,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.updated_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_AddMemberModal, {
      id: _ctx.modelId,
      "parent-id": parseInt(_ctx.$route.params.id),
      onUpdateList: _ctx.getWechatCommunityMemberList,
      onResetForm: _ctx.handleAddModel
    }, null, 8, ["id", "parent-id", "onUpdateList", "onResetForm"]),
    _createVNode(_component_AddcommunityModal, {
      id: _ctx.modelId,
      "parent-id": parseInt(_ctx.$route.params.id),
      onUpdateList: _ctx.updateModelList,
      onResetForm: _ctx.handleAddModel
    }, null, 8, ["id", "parent-id", "onUpdateList", "onResetForm"])
  ], 64))
}